import React from 'react';
import Eficiencia from '../SideCards/Eficiencia/Eficiencia';
import './Partners.css';

function Eficienty() {
  return (
    <section className="partners_container">
      <Eficiencia />
    </section>
  );
}

export default Eficienty;
